export const APP_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
  { code: "kn", label: "Kannada" },
];

export const TRANSLATABLE_LANGUAGES = APP_LANGUAGES.filter(({ code }) => code !== "en");

export const SUPPORT_QUERY_LANGUAGES = [
  { code: "kn", label: "Kannada" },
  { code: "te", label: "Telugu" },
  { code: "ta", label: "Tamil" },
  { code: "sa", label: "Sanskrit" },
  { code: "hi", label: "Hindi" },
  { code: "en", label: "English" },
  { code: "mr", label: "Marathi" },
];

export const buildNotificationTranslationsPayload = (fields = {}) => ({
  title: (fields.titleEn || fields.title || "").trim(),
  message: (fields.messageEn || fields.message || "").trim(),
  titleHi: (fields.titleHi || "").trim(),
  messageHi: (fields.messageHi || "").trim(),
  titleKn: (fields.titleKn || "").trim(),
  messageKn: (fields.messageKn || "").trim(),
});
